/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartnerSearchByBrResponse } from './PartnerSearchByBrResponse';
import {
    PartnerSearchByBrResponseFromJSON,
    PartnerSearchByBrResponseFromJSONTyped,
    PartnerSearchByBrResponseToJSON,
    PartnerSearchByBrResponseToJSONTyped,
} from './PartnerSearchByBrResponse';

/**
 * Search result containing the returned partners and total number of matches
 * @export
 * @interface PartnerSearchByBrResult
 */
export interface PartnerSearchByBrResult {
    /**
     * Partners returned for the current search request
     * @type {Array<PartnerSearchByBrResponse>}
     * @memberof PartnerSearchByBrResult
     */
    partners?: Array<PartnerSearchByBrResponse>;
    /**
     * Total number of matching partners reported by the search service
     * @type {number}
     * @memberof PartnerSearchByBrResult
     */
    total?: number;
}

/**
 * Check if a given object implements the PartnerSearchByBrResult interface.
 */
export function instanceOfPartnerSearchByBrResult(value: object): value is PartnerSearchByBrResult {
    return true;
}

export function PartnerSearchByBrResultFromJSON(json: any): PartnerSearchByBrResult {
    return PartnerSearchByBrResultFromJSONTyped(json, false);
}

export function PartnerSearchByBrResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerSearchByBrResult {
    if (json == null) {
        return json;
    }
    return {
        
        'partners': json['partners'] == null ? undefined : ((json['partners'] as Array<any>).map(PartnerSearchByBrResponseFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
    };
}

export function PartnerSearchByBrResultToJSON(json: any): PartnerSearchByBrResult {
    return PartnerSearchByBrResultToJSONTyped(json, false);
}

export function PartnerSearchByBrResultToJSONTyped(value?: PartnerSearchByBrResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'partners': value['partners'] == null ? undefined : ((value['partners'] as Array<any>).map(PartnerSearchByBrResponseToJSON)),
        'total': value['total'],
    };
}

